import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User } from 'lucide-react';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent } from '../components/ui/card';

const API = process.env.REACT_APP_BACKEND_URL;

const formatError = (detail) => {
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || '').join(' ');
  return 'Ndodhi një gabim. Provoni përsëri.';
};

export default function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/api/auth/login`, { username, password });
      localStorage.setItem('lor95_admin_token', data.token);
      navigate('/admin');
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || 'Gabim në lidhje');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-none shadow-2xl">
        <CardContent className="p-10">
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-900 mb-4">
              <Lock className="h-7 w-7 text-white" />
            </div>
            <h1 className="text-3xl font-serif font-bold text-gray-900">Lor95 Boutique</h1>
            <p className="text-gray-500 mt-2">Paneli i Administratorit</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="username">Përdoruesi</Label>
              <div className="relative mt-2">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  id="username"
                  data-testid="admin-username-input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="pl-10 rounded-none"
                  placeholder="admin"
                />
              </div>
            </div>
            <div>
              <Label htmlFor="password">Fjalëkalimi</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  id="password"
                  data-testid="admin-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="pl-10 rounded-none"
                  placeholder="••••••••"
                />
              </div>
            </div>

            {error && (
              <p data-testid="admin-login-error" className="text-sm text-red-600 bg-red-50 border border-red-200 px-4 py-3">
                {error}
              </p>
            )}

            <Button
              type="submit"
              data-testid="admin-login-submit-btn"
              disabled={loading}
              className="w-full bg-gray-900 hover:bg-gray-800 text-white rounded-none py-6 font-semibold"
            >
              {loading ? 'Duke hyrë...' : 'Hyr në Panel'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
